import Api from './Api'

export default {
  save (data) {
    return Api().post('/signature.json', data)
  },

  list (kundenr, queryParams) {
    return Api().get(`/kunde/${kundenr}/signature.json`, {
      params: queryParams
    })
  },

  getPdf (kundenr, objektid) {
    return Api().get(`/kunde/${kundenr}/objekt/${objektid}/signature.json`)
  }
}



// WEBPACK FOOTER //
// ./src/services/SignatureService.js